import { SEARCH_PERSISTENCE_ACTION_TYPES } from 'src/utils/constants/common'

const initialState = {
  viewPolicyDashboardFilters: {},
}

const searchPersistenceReducer = (state = initialState, action = {}) => {
  if (
    action.type ===
    SEARCH_PERSISTENCE_ACTION_TYPES.setViewPolicyDashboardFilters
  ) {
    return { ...state, viewPolicyDashboardFilters: { ...action.payload } }
  } else if (
    action.type === SEARCH_PERSISTENCE_ACTION_TYPES.setPolicyCitiesFilters
  ) {
    return { ...state, policyCitiesFilters: { ...action.payload } }
  } else {
    return state
  }
}

export default searchPersistenceReducer
